'use client';
import { Container } from '@/layers/presentation/components/common/Container';
import ProgramSearchFilters from '@/layers/presentation/components/programs/ProgramSearchFilters';
import ProgramsList from '@/layers/presentation/components/programs/ProgramsList';
import SubscriptionPrompt from '@/layers/presentation/components/ui/SubscriptionPrompt';
import { useLogger, useProgramSearch } from '@/layers/presentation/hooks';
import { UserType } from '@/types/modelEnums';

const LOG_MODULE = '[Pages / Provider / Programs]';

/**
 * Client-side portion of the provider program search page.
 * Extracted verbatim from the original `page.tsx` so the server parent can
 * own metadata + SSR copy. See T-0108 plan step 5.
 */
export default function ProviderSearchProgramClient() {
  const {
    selectedOptions,
    query,
    handleParamChange,
    handleQueryChange,
    handleSaveSearch,
    initialSettleReady,
    uiFiltersStrict,
    listFilters,
  } = useProgramSearch();

  useLogger({
    module: LOG_MODULE,
    props: {
      selectedOptions,
      query,
    },
  });

  return (
    <>
      <Container>
        <ProgramSearchFilters
          filters={uiFiltersStrict}
          onParamChange={handleParamChange}
          onQueryChange={handleQueryChange}
        />
        <ProgramsList
          type={UserType.PROVIDER}
          filters={listFilters}
          onSaveSearch={handleSaveSearch}
          showDefaultRecent={true}
          ready={initialSettleReady}
        />
      </Container>
      <SubscriptionPrompt
        prompt={{
          title: 'Get Treatment Updates Straight to Your Email',
          text: 'Right2Hope will also continue searching for new matching programs and will notify you via email as soon as they become available.',
          button: 'Subscribe to Updates',
        }}
        modal={{
          title: 'Get Treatment Updates Straight to Your Email',
          text: 'Right2Hope will also continue searching for new matching programs and will notify you via email as soon as they become available.',
          button: 'Subscribe Now',
        }}
        params={{
          query,
          patientParams: selectedOptions || {},
          userType: UserType.PROVIDER,
        }}
        background="bg-[#F5F9D8]"
      />
    </>
  );
}
